import React from 'react';
import { Button } from 'primereact/button';
import CustomTooltip from '../../../shared/components/common/tooltip/CustomTooltip';
import { AccountStatus } from '../../../shared/types/account/AccountStatus';

interface ActionBtnProps {
  projectId: number;
  isSuperAdminPermission: boolean;
  accountStatus: AccountStatus;
  demoVersion: string | null;
  confirmDuplicate: (projectId: number) => void;
  confirmRemove: (projectId: number) => void;
  editName: (projectId: number) => void;
  canMoveToGroup?: boolean;
  onMoveClick?: (e: React.MouseEvent) => void;
}

const ActionBtn: React.FC<ActionBtnProps> = ({
  projectId,
  isSuperAdminPermission,
  accountStatus,
  demoVersion,
  confirmDuplicate,
  editName,
  confirmRemove,
  canMoveToGroup,
  onMoveClick,
}) => {
  return (
    <div className="buttons-list">
      {isSuperAdminPermission && (
        <>
          <Button
            id={`btn-copy-project-${projectId}`}
            className="action-btn"
            onClick={() => confirmDuplicate(projectId)}
          >
            <span className="ico--copy ico--xs" />
          </Button>
          <CustomTooltip tooltipText="copyProject" targetRef={`btn-copy-project-${projectId}`} />
        </>
      )}
      {(!demoVersion || isSuperAdminPermission) && !['BLOCKED', 'DISABLED'].includes(accountStatus) && (
        <>
          <Button
            id={`btn-edit-project-${projectId}`}
            className="action-btn"
            onClick={() => editName(projectId)}
          >
            <span className="ico--edit ico--xs" />
          </Button>
          <CustomTooltip tooltipText="editProject" targetRef={`btn-edit-project-${projectId}`} />
        </>
      )}
      {canMoveToGroup && onMoveClick && (
        <>
          <Button
            id={`btn-move-project-${projectId}`}
            className="action-btn"
            onClick={onMoveClick}
          >
            <span className="ico--move ico--xs" />
          </Button>
          <CustomTooltip tooltipText="moveToGroup" targetRef={`btn-move-project-${projectId}`} />
        </>
      )}
      <Button
        id={`btn-remove-project-${projectId}`}
        className="action-btn"
        onClick={() => confirmRemove(projectId)}
      >
        <span className="ico--trash ico--xs" />
        <CustomTooltip tooltipText="removeProject" targetRef={`btn-remove-project-${projectId}`} />
      </Button>
    </div>
  );
};

export default ActionBtn;
